
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { SEOHead } from '@/components/SEOHead';
import { StructuredData, OrganizationSchema, WebPageSchema } from '@/components/StructuredData';
import { PageHeader } from '@/components/PageHeader';

const About = () => {
  const organizationSchema: OrganizationSchema = {
    '@type': 'Organization',
    name: 'GrowthLens',
    url: 'https://growthlens.in',
    logo: 'https://growthlens.in/src/assets/logo-default.png',
    description: 'B2B marketing consultancy that partners with SMEs to build structured, scalable growth models.',
    address: {
      '@type': 'PostalAddress',
      addressCountry: 'IN'
    }
  };

  const webPageSchema: WebPageSchema = {
    '@type': 'WebPage',
    name: 'About GrowthLens',
    url: 'https://growthlens.in/about',
    description: 'Learn about GrowthLens and our mission to empower B2B businesses through intelligent assessments, structured growth models, and expert marketing consultancy.',
    publisher: organizationSchema
  };

  return (
    <>
      <SEOHead 
        title="About GrowthLens - Our Mission & Team"
        description="Learn about GrowthLens and our mission to empower B2B businesses through intelligent assessments, structured growth models, and expert marketing consultancy."
        canonical="https://growthlens.in/about"
      />
      <StructuredData data={webPageSchema} />
      <div className="min-h-screen bg-gradient-to-br from-background to-muted">
      <PageHeader 
        heading="About Us"
        description="Empowering growth through intelligent assessments"
      />
      <div className="container mx-auto px-4 py-8">
        <div className="max-w-4xl mx-auto">
          
          <div className="grid gap-6">
            <Card className="card-enhanced hover-lift animate-fade-in transition-all duration-300 border-primary/10">
              <CardHeader className="pb-4">
                <CardTitle className="text-center text-2xl bg-gradient-to-r from-primary to-primary/70 bg-clip-text text-transparent">
                  Our Mission
                </CardTitle>
              </CardHeader>
              <CardContent>
                <p className="text-muted-foreground leading-relaxed text-center">
                  We are dedicated to providing comprehensive assessment tools that help individuals and organizations 
                  understand their strengths, identify areas for improvement, and make informed decisions for growth.
                </p>
              </CardContent>
            </Card>

            <Card className="card-enhanced hover-lift animate-fade-in transition-all duration-300 border-primary/10" style={{ animationDelay: '0.1s' }}>
              <CardHeader className="pb-4">
                <CardTitle className="text-center text-2xl bg-gradient-to-r from-primary to-primary/70 bg-clip-text text-transparent">
                  What We Offer
                </CardTitle>
              </CardHeader>
              <CardContent>
                <ul className="space-y-3 text-muted-foreground">
                  <li className="flex items-start gap-3 transition-transform duration-200 hover:translate-x-1">
                    <span className="text-primary mt-1">•</span>
                    <span>Professional assessment tools designed by experts</span>
                  </li>
                  <li className="flex items-start gap-3 transition-transform duration-200 hover:translate-x-1">
                    <span className="text-primary mt-1">•</span>
                    <span>Detailed analytics and insights</span>
                  </li>
                  <li className="flex items-start gap-3 transition-transform duration-200 hover:translate-x-1">
                    <span className="text-primary mt-1">•</span>
                    <span>Secure and confidential data handling</span>
                  </li>
                  <li className="flex items-start gap-3 transition-transform duration-200 hover:translate-x-1">
                    <span className="text-primary mt-1">•</span>
                    <span>Easy-to-understand results and recommendations</span>
                  </li>
                  <li className="flex items-start gap-3 transition-transform duration-200 hover:translate-x-1">
                    <span className="text-primary mt-1">•</span>
                    <span>Premium features for advanced analysis</span>
                  </li>
                </ul>
              </CardContent>
            </Card>

            <Card className="card-enhanced hover-lift animate-fade-in transition-all duration-300 border-primary/10" style={{ animationDelay: '0.2s' }}>
              <CardHeader className="pb-4">
                <CardTitle className="text-center text-2xl bg-gradient-to-r from-primary to-primary/70 bg-clip-text text-transparent">
                  Our Team
                </CardTitle>
              </CardHeader>
              <CardContent>
                <p className="text-muted-foreground leading-relaxed text-center">
                  Our team consists of experienced professionals in psychology, data science, and technology, 
                  working together to create the most effective assessment platform available.
                </p>
              </CardContent>
            </Card>
          </div>
        </div>
      </div>
      </div>
    </>
  );
};

export default About;